const TEXT = "Residential · Commercial · Interior · Exterior · Colour Consultation · Specialty Finishes ·";

export default function Marquee({ reverse = false }) {
  const items = Array(2).fill(TEXT);
  return (
    <div
      data-testid="marquee"
      className="border-y-2 border-[#111] bg-[#F2F2EF] py-5 overflow-hidden"
    >
      <div className={`marquee-track ${reverse ? "marquee-rev" : ""}`}>
        {items.map((t, i) => (
          <div
            key={i}
            className="font-display text-3xl md:text-5xl lg:text-6xl tracking-tight uppercase pr-12 whitespace-nowrap"
          >
            {t} <span className="text-[#D85C3A]">·</span> {t}
          </div>
        ))}
      </div>
    </div>
  );
}
